import axios from "axios";
import { data } from "jquery";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import service from "../services/service";
import cookies from "js-cookie";

export default function IVPChariot() {
  const { search } = useLocation();
  const history = useHistory();

  useEffect(async () => {
    const parameters = new URLSearchParams(search);
    const code = parameters.get("code");
    // const state = parameters.get("state");
   
    if (cookies.get("token") && cookies.get("refreshtoken")) {
      cookies.remove("token");
      cookies.remove("refreshtoken");
      ivpGetToken(code
        // ,state
      );
      history.push(`${process.env.PUBLIC_URL}/`);
    } else {
      ivpGetToken(code);
    }
  });

  const ivpGetToken = async (code,state) => {
    await service
      .ivpGetToken(code
        // ,state
      )
      .then(async (resp) => {
        
        if (resp.data) {
          cookies.set("token", resp.data?.AccessToken?.access_token);
          cookies.set("refreshtoken", resp.data?.AccessToken?.refresh_token);
          sessionStorage.setItem("xyz_checking", resp.data?.userId);
          history.push(`${process.env.PUBLIC_URL}/`);
          window.location.reload();
        }
      })
      .catch((err) => {
        window.location.reload();
        // prompt("Error Open")
        
      });
  };

  return (
    <div class="loader">
      <span>
        <img
          src={`${process.env.PUBLIC_URL}/chariot/assets/images/chariotLogo.png`}
          alt="Logo"
          class="logo_loader"
        />
      </span>
      <div class="loader__element_component">
        <span class="loader__element"></span>
        <span class="loader__element"></span>
        <span class="loader__element"></span>
      </div>
    </div>
  );
}
